import * as Yup from 'yup';
import { ROLE_OPTIONS } from 'Screens/userEditForm';
import { AUTH_ERRORS } from 'Constants/ErrorMessages';
import AuthModel from 'models/auth';
import { PASSWORD_VALIDATION_REGEXP } from 'Constants/variables';
import { TRole } from '../../../models/auth/@types';

const commonSchema = {
  role: Yup.string().oneOf(ROLE_OPTIONS.map(r => r.value)),
  first_name: Yup.string().required(AUTH_ERRORS.FIRST_NAME_REQUIRED),
  last_name: Yup.string().required(AUTH_ERRORS.LAST_NAME_REQUIRED),
  organization: Yup.string().when('role', {
    is: (value: TRole) => [TRole.STUDENT, TRole.TEACHER].includes(value),
    then: schema => schema.required(AUTH_ERRORS.SCHOOL_REQUIRED),
    otherwise: schema =>
      schema.when('role', {
        is: TRole.MENTOR,
        then: schema => schema.required(AUTH_ERRORS.COMPANY_REQUIRED),
      }),
  }),
  industry: Yup.string().when('role', {
    is: TRole.MENTOR,
    then: schema => schema.required(AUTH_ERRORS.INDUSTRY_REQUIRED),
  }),
  city: Yup.string(),
  state: Yup.string().when('role', {
    is: (value: TRole) => [TRole.STUDENT, TRole.TEACHER].includes(value),
    then: schema => schema.required(AUTH_ERRORS.STATE_REQUIRED),
  }),
  naf_academy: Yup.string().when('role', {
    is: (value: TRole) => [TRole.STUDENT, TRole.TEACHER].includes(value),
    then: schema => schema.required(AUTH_ERRORS.NAF_ACADEMY_REQUIRED),
  }),
  is_policy_accepted: Yup.boolean()
    .oneOf([true], AUTH_ERRORS.CONFIRMATIONS_REQUIRED)
    .required(AUTH_ERRORS.CONFIRMATIONS_REQUIRED),
  is_role_accepted: Yup.boolean()
    .oneOf([true], AUTH_ERRORS.CONFIRMATIONS_REQUIRED)
    .required(AUTH_ERRORS.CONFIRMATIONS_REQUIRED),
};

export const ValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email(AUTH_ERRORS.EMAIL_VALIDATION_NOT_MATCH)
    .required(AUTH_ERRORS.EMAIL_REQUIRED)
    .test('emailExists', AUTH_ERRORS.EMAIL_ALREADY_EXISTS, async value => {
      if (!value) return true;
      const isEmailExists = await AuthModel.isEmailExists(value);
      if (isEmailExists === undefined) return true;
      return !isEmailExists;
    }),
  password: Yup.string()
    .matches(PASSWORD_VALIDATION_REGEXP, AUTH_ERRORS.PASSWORD_VALIDATION_NOT_MATCH)
    .required(AUTH_ERRORS.PASSWORD_REQUIRED),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], AUTH_ERRORS.CONFIRM_PASSWORD_NOT_MATCH)
    .required(AUTH_ERRORS.CONFIRM_PASSWORD_REQUIRED),
  mentorCode: Yup.string().when('role', {
    is: TRole.MENTOR,
    then: schema => schema.required(AUTH_ERRORS.MENTOR_CODE_REQUIRED),
  }),
  ...commonSchema,
});

export const ValidationSchemaSSO = Yup.object().shape({
  mentorCode: Yup.string().when('role', {
    is: TRole.MENTOR,
    then: schema => schema.required(AUTH_ERRORS.MENTOR_CODE_REQUIRED),
  }),
  ...commonSchema,
});
